import {
  Component,
  EventEmitter,
  OnInit,
  Output,
  ViewChild,
} from "@angular/core";
import { MatTableDataSource } from "@angular/material/table";
import { MatPaginator } from "@angular/material/paginator";
import { CompetensesResponse, Course } from "src/app/interfaces/response";
import { SectoresProductivosService } from "src/app/services/sectores-productivos.service";
import { ActivatedRoute } from "@angular/router";

@Component({
  selector: "app-renap-table-principal",
  templateUrl: "./renap-table-principal.component.html",
  styleUrls: ["./renap-table-principal.component.css"],
})
export class RenapTablePrincipalComponent {
  displayedColumns: string[] = [
    "nombreCurso",
    "capacitador",
    "estandar",
    "estado",
    "modalidad",
    "modalidad2",
    "modalidad3",
  ];
  dataSource = new MatTableDataSource<CompetensesResponse>();
  totalElements: number = 0;
  pageSize: number = 30;
  pageNumber: number = 1;
  code: string = "";
  filterTimeout: any;
  debounceTimer: any;
  activeEror: boolean;
  competences: CompetensesResponse[] = [];
  @ViewChild(MatPaginator) paginator!: MatPaginator;
  @Output() courseSelected = new EventEmitter<Course>();

  constructor(
    private service: SectoresProductivosService,
    private route:ActivatedRoute,
  ) {}

  ngOnInit() {
    this.route.paramMap.subscribe( params => {
      const curp = params.get('curp');
      if(curp) {
        this.applyFilter(curp)
      }
    })
  }

  sectorByID(course: Course) {
    this.courseSelected.emit(course);
  }

  downloads() {
    this.exportToCSV(this.competences);
  }

  getCursos(data: string, download?: boolean): void {
    this.service.getListRenap(data).subscribe({
      next: (data) => {
        this.competences = data;
        this.dataSource.data = this.competences;
        if (!this.competences || this.competences.length === 0) {
          this.activeEror = true;
        } else {
          this.activeEror = false;
        }
      },
      error: (error) => {
        console.error("Error al obtener data:", error);
      },
    });
  }

  applyFilter(value: string) {
    console.log("EVENT: ", value)
    const filterValue = value;// (event.target as HTMLInputElement).value;
    console.log("filterValue: ", filterValue)
    clearTimeout(this.debounceTimer);
    this.debounceTimer = setTimeout(() => {
      if (filterValue !== "" && filterValue !== null) {
        this.getCursos(filterValue);
      }
    }, 1000);
  }

  exportToCSV(data: any[]): void {
    const csvContent = this.convertToCSV(data);
    const bom = "\uFEFF";
    const blob = new Blob([bom + csvContent], {
      type: "text/csv;charset=utf-8;",
    });
    const link = document.createElement("a");
    const url = URL.createObjectURL(blob);
    link.setAttribute("href", url);
    link.setAttribute("download", "renap_datos.csv");
    link.style.visibility = "hidden";
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  }

  private convertToCSV(data: any[]): string {
    if (!data || data.length === 0) {
      return "";
    }

    const header = "Folio,Tipo,Código,Título,Entidad de certificación,Siglas, Evaluador Centro de evaluación";

    const rows = data.map((row) =>
      [
        row.folio,
        row.tipoCertificado,
        row.codigo,
        row.normaEstandar,
        row.certificador,
        row.siglasCertificador,
        row.evaluador
      ]
        .map((value) => `"${value || ""}"`)
        .join(",")
    );

    return [header, ...rows].join("\n");
  }
}
